// deno-fmt-ignore-file
function* CreateIterator() { }
export function FromIterator(context, type) {
    return CreateIterator();
}
